<script>
    import * as Icons from 'lucide-svelte';
    import LySection from '../../layouts/components/LySection.svelte';
    import LyHeadline from '../../layouts/components/LyHeadline.svelte';
    import LyContent from '../../layouts/components/LyContent.svelte';
    import LyHeader from '../../layouts/components/LyHeader.svelte';
    import LyP from '../../layouts/components/LyP.svelte';
    import LyForm from '../../layouts/forms/LyForm.svelte';
    import LyInputText from '../../layouts/forms/LyInputText.svelte';
    import LyInputSelect from '../../layouts/forms/LyInputSelect.svelte';
    import {
        INDENT_MODE_OPTIONS,
        IndentMode,
        LINE_MODE_OPTIONS,
        LineMode,
        NormalizeService,
        SPACE_MODE_OPTIONS,
        SpaceMode,
    } from '../../services/NormalizeService.js';
    import { DiffService } from '../../services/DiffService.js';
    import LyFieldset from '../../layouts/forms/LyFieldset.svelte';
    import LyGrid3 from '../../layouts/components/LyGrid3.svelte';
    import LyDiffView from '../../layouts/components/LyDiffView.svelte';

    let plainText = $state('');
    let lineMode = $state(LineMode.MULTI_MAX_ONE_EMPTY);
    let spaceMode = $state(SpaceMode.COLLAPSE);
    let indentMode = $state(IndentMode.REMOVE);
    let showDiff = $state(false);

    const result = $derived(NormalizeService.normalize(plainText, lineMode, spaceMode, indentMode) ?? '');
    const stats = $derived(DiffService.getStats(plainText, result));
    const diffLines = $derived(DiffService.diffLines(plainText, result));

    const charsRemoved = $derived(Math.max(0, stats.charsBefore - stats.charsAfter));
    const charsAdded = $derived(Math.max(0, stats.charsAfter - stats.charsBefore));
</script>

<LyContent wrapper={true}>
    <LyHeader>
        <LyHeadline icon={Icons.PencilRuler}>Klartext-Bereinigung</LyHeadline>
    </LyHeader>

    <LySection tag="div">
        <LyP>Texte aus KI oder externen Quellen normalisieren.</LyP>
    </LySection>
</LyContent>

<LyContent tag="div" wrapper={true} mt={true}>
    <LyForm>
        <LyFieldset label="Eingabe">
            <LyInputText
                type="area"
                name="plain"
                label="Klartext (PLAIN)"
                description="Hier den Text mit Copy&amp;Paste einfügen."
                placeholder=""
                fullWidth={true}
                bind:value={plainText} />

            <LyGrid3 tag="div" mt={true}>
                <LyInputSelect name="lineMode" label="Leerzeilen" options={LINE_MODE_OPTIONS} bind:value={lineMode} />

                <LyInputSelect
                    name="spaceMode"
                    label="Doppelte Leerzeichen"
                    options={SPACE_MODE_OPTIONS}
                    bind:value={spaceMode} />

                <LyInputSelect
                    name="indentMode"
                    label="Führende Leerzeichen"
                    options={INDENT_MODE_OPTIONS}
                    bind:value={indentMode} />
            </LyGrid3>
        </LyFieldset>

        <LyFieldset mt={true} label="Ausgabe">
            <LyInputText
                type="area"
                name="result"
                description="Bereinigt: PLAIN, UTF-8"
                placeholder=""
                fullWidth={true}
                readonly={true}
                disabled={true}
                value={result} />
        </LyFieldset>
    </LyForm>
</LyContent>

{#if plainText !== ''}
    <LyContent mt={true}>
        <LyHeader>
            <LyHeadline icon={Icons.FileDiff} weight={2}>Änderungen</LyHeadline>
        </LyHeader>

        <LyP>
            {#if stats.changed}
                <strong>{charsRemoved}</strong> Zeichen entfernt
                {#if charsAdded > 0},
                    <strong>{charsAdded}</strong> hinzugefügt
                {/if} &middot;
                <strong>{stats.linesBefore}</strong> →&nbsp;<strong>{stats.linesAfter}</strong> Zeilen
                {#if stats.linesRemoved > 0}
                    (<strong>{stats.linesRemoved}</strong> entfernt)
                {/if}
            {:else}
                Keine Änderungen vorgenommen&hellip;
            {/if}
        </LyP>

        {#if stats.changed}
            <button
                type="button"
                class="text-secondary-600 mt-2 cursor-pointer text-sm underline"
                onclick={() => (showDiff = !showDiff)}>
                {showDiff ? 'Diff ausblenden' : 'Diff anzeigen'}
            </button>

            {#if showDiff}
                <div class="mt-2">
                    {#if diffLines !== null}
                        <LyDiffView lines={diffLines} />
                    {:else}
                        <LyP>Text hat zu viele Zeilen für eine Diff-Ansicht.</LyP>
                    {/if}
                </div>
            {/if}
        {/if}
    </LyContent>
{/if}
